import styled from 'styled-components';
import { theme } from 'constants/theme';

export const Frame = styled.div`
  font-family: Montserrat;
  font-style: normal;
  color: ${theme.main.white};
`;
